import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import es from './es'
import { store } from '../store'

Vue.use(VueI18n, store)

const messages = {
    'en': en,
    'es': es
}

const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'es': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const numberFormats = {
  'en': {
    currency: {
      style: 'currency', currency: 'USD'
    },
    currency6Decimal: {
      style: 'currency', currency: 'USD', minimumFractionDigits: 6
    },
    percent: {
      style: 'percent'
    }
  },
  'es': {
    currency: {
      style: 'currency', currency: 'USD'
    },
    currency6Decimal: {
      style: 'currency', currency: 'USD', minimumFractionDigits: 6
    },
    percent: {
      style: 'percent'
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
  dateTimeFormats, // set date and time formats
  numberFormats // set number formats
})

export default i18n